import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import TodayTimeTable from "../todayTimeTable";
import { Card } from "react-bootstrap";
import FullTimetable from "./fullTimetable";

const MyTimetable = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="My Time Table" />
      <div className="container-sm py-md-3" data-aos="zoom-in">
        <TodayTimeTable />
        <Card className="mt-3">
          <Card.Header className="fw-bold text-uppercase card-header-bg">
            My Timetable
          </Card.Header>
          <Card.Body className="p-0">
            <FullTimetable />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
export default MyTimetable;
